
import React from 'react';
import { Radio, Slider, DateTimeInput, Input, Static, CheckboxGroup } from '../../../common/components/formControls';
import { Form, Panel } from 'react-bootstrap';
import { Field } from 'redux-form';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';

const yesNoOptions = (t) => {
	return [
		{ label: t('Yes'), value: 'true' },
		{ label: t('No'), value: 'false' }
	];
};

const parseBoolean = value => value === 'true' ? true : false;

const frequencyOptions = size => [...Array(size).keys()].map(x => ({ value: `${x + 1}`, label: `${x + 1}` }));

const percentageSliderProps = {
	min: 0, max: 100, step: 10,
	valueLabelFormat: value => `${value}%`,
	valueLabelDisplay: 'on',
	marks: [...Array(11).keys()].map(x => ({ value: x * 10, label: `${x * 10}%` }))
};

const FollowUp = ({ t }) => {
	const colSize = { labelCol: 5, valueCol: 7 };
	return (
		<Form >
			<Panel>
				<Panel.Heading>{t('Summary')}</Panel.Heading>
				<Panel.Body>
					<Field name='summary_1' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('Summary_1')} disabled {...colSize} />
					<Field name='summary_1_1' component={Input} componentClass='textarea' horizontal label={t('Summary_1_1')} disabled {...colSize} />
					<Field name='summary_2' component={DateTimeInput} showTime={false} horizontal label={t('Summary_2')} disabled {...colSize} />
					<Field name='summary_3' component={Slider} {...percentageSliderProps} horizontal label={t('Summary_3')} disabled {...colSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('PrimitiveReflexes')}</Panel.Heading>
				<Panel.Body>
					<Field name='primitiveReflexes_1' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('PrimitiveReflexes_1')} disabled {...colSize} />
					<Field name='primitiveReflexes_1_1' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('PrimitiveReflexes_1_1')} disabled {...colSize} />
					<Field name='primitiveReflexes_1_2' component={Static} inline horizontal label={t('PrimitiveReflexes_1_2')} disabled {...colSize} />
					<Field name='primitiveReflexes_1_2_1' component={Radio} entries={frequencyOptions(7)} parse={value => Number(value)} inline horizontal label={t('PrimitiveReflexes_1_2_1')} disabled {...colSize} />
					<Field name='primitiveReflexes_1_2_2' component={Radio} entries={frequencyOptions(7)} parse={value => Number(value)} inline horizontal label={t('PrimitiveReflexes_1_2_2')} disabled {...colSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('HemisphericSensory')}</Panel.Heading>
				<Panel.Body>
					<Field name='hemisphericSensory_1' component={CheckboxGroup} entries={[
						{ value: 'light', label: t('HemisphericSensory_1_Light') },
						{ value: 'sound', label: t('HemisphericSensory_1_Sound') },
						{ value: 'smell', label: t('HemisphericSensory_1_Smell') },
						{ value: 'spinning', label: t('HemisphericSensory_1_Spinning') },
						{ value: 'opk', label: t('HemisphericSensory_1_OPK') },
						{ value: 'trackingsubject', label: t('HemisphericSensory_1_TrackingSubject') },
						{ value: 'tactile', label: t('HemisphericSensory_1_Tactile') },
						{ value: 'eyelights', label: t('HemisphericSensory_1_Eyelights') },
						{ value: 'tens', label: t('HemisphericSensory_1_Tens') }
					]} inline horizontal label={t('HemisphericSensory_1')} disabled {...colSize} />
					<Field name='hemisphericSensory_1_other' component={Input} componentClass='textarea' horizontal label={t('HemisphericSensory_1_Other')} disabled {...colSize} />
					<Field name='hemisphericSensory_1_1' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('HemisphericSensory_1_1')} disabled {...colSize} />
					<Field name='hemisphericSensory_1_2' component={Static} inline horizontal label={t('HemisphericSensory_1_2')} disabled {...colSize} />
					<Field name='hemisphericSensory_1_2_1' component={Radio} entries={frequencyOptions(7)} parse={value => Number(value)} inline horizontal label={t('HemisphericSensory_1_2_1')} disabled {...colSize} />
					<Field name='hemisphericSensory_1_2_2' component={Radio} entries={frequencyOptions(7)} parse={value => Number(value)} inline horizontal label={t('HemisphericSensory_1_2_2')} disabled {...colSize} />
					<Field name='hemisphericSensory_2' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('HemisphericSensory_2')} disabled {...colSize} />
					<Field name='hemisphericSensory_2_1' component={Input} componentClass='textarea' horizontal label={t('HemisphericSensory_2_1')} disabled {...colSize} />
					<Field name='hemisphericSensory_3' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('HemisphericSensory_3')} disabled {...colSize} />
					<Field name='hemisphericSensory_3_1' component={Input} componentClass='textarea' horizontal label={t('HemisphericSensory_3_1')} disabled {...colSize} />
					<Field name='hemisphericSensory_4' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('HemisphericSensory_4')} disabled {...colSize} />
					<Field name='hemisphericSensory_4_1' component={Input} componentClass='textarea' horizontal label={t('HemisphericSensory_4_1')} disabled {...colSize} />
					<Field name='hemisphericSensory_5' component={Slider} {...percentageSliderProps} horizontal label={t('HemisphericSensory_5')} disabled {...colSize} />
					<Field name='hemisphericSensory_6' component={Slider} {...percentageSliderProps} horizontal label={t('HemisphericSensory_6')} disabled {...colSize} />
					<Field name='hemisphericSensory_7' component={Slider} {...percentageSliderProps} horizontal label={t('HemisphericSensory_7')} disabled {...colSize} />
					<Field name='hemisphericSensory_8' component={Slider} {...percentageSliderProps} horizontal label={t('HemisphericSensory_8')} disabled {...colSize} />
					<Field name='hemisphericSensory_9' component={Slider} {...percentageSliderProps} horizontal label={t('HemisphericSensory_9')} disabled {...colSize} />
					<Field name='hemisphericSensory_10' component={Slider} {...percentageSliderProps} horizontal label={t('HemisphericSensory_10')} disabled {...colSize} />
					<Field name='hemisphericSensory_11' component={Input} componentClass='textarea' horizontal label={t('HemisphericSensory_11')} disabled {...colSize} />
				</Panel.Body>
			</Panel>
		</Form>
	);
};

export default withResourcesNamespace(props => props.resourcesNamespace)(FollowUp);